import {adaptador_pedido_pago} from "../Adaptadores/adaptador_pedido_pago";
import axios from "axios";

export const envioDatosMercadoPago = (entidad) => {

    let pago = adaptador_pedido_pago(entidad)

    let data = JSON.stringify(pago);

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        //url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook-test/8b56bb1e-d98b-4af4-9b70-54cd5bacc3b8', //test
        url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook/8b56bb1e-d98b-4af4-9b70-54cd5bacc3b8',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    return axios.request(config)
        .then((response) => {
            return response.data
        })
        .catch((error) => {
            return error.message;
        });


}